import { connect } from "react-redux";
import SortPeopleToggle from "./SortPeopleToggle";
import { setPeopleSort, SORT_BY } from "./actions/sort";

const mapStateToProps = (state, ownProps) => {
  return {
    sortBy: state.ui.sortPeople
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSortBy: key => {
      if (key === "role") {
        dispatch(setPeopleSort(SORT_BY.ROLE));
      } else {
        dispatch(setPeopleSort(SORT_BY.DATE_DESC));
      }
    }
  };
};

const SortPeopleToggleContainer = connect(mapStateToProps, mapDispatchToProps)(
  SortPeopleToggle
);

export default SortPeopleToggleContainer;



// WEBPACK FOOTER //
// ./src/SortPeopleToggleContainer.js